import React, { useEffect } from 'react';
import './index.scss';
import { Link, useLocation } from 'react-router-dom';
import { Button, Modal, Space } from 'antd';
import logger from '../../logger';
import { OtaComplianceAccount } from '../../types/global_reducer';

interface OtaNotificationModalProps {
  visible?: boolean;
  otaCompliance?: OtaComplianceAccount[];
  actions: {
    hideModal: () => void;
    submitApproval: (nonCompliantAccounts?: OtaComplianceAccount[]) => void;
    updateOtaCompliance: () => void;
  };
  flags?: {
    team33111ShowCompliancePopup?: boolean;
  };
}

const OtaNotificationModal = ({
  visible,
  otaCompliance,
  actions,
  flags: { team33111ShowCompliancePopup } = {},
}: OtaNotificationModalProps) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === '#ota-notification' && otaCompliance == null && team33111ShowCompliancePopup) {
      try {
        actions.updateOtaCompliance();
      } catch (error) {
        logger.error(`Failed to update OTA compliance during login redirect: ${error}`);
      }
    }
  }, [hash, actions, otaCompliance, team33111ShowCompliancePopup]);

  if (!team33111ShowCompliancePopup) return null;
  const nonCompliantAccounts = otaCompliance?.filter(account => account.nonCompliantLRUCount > 0);
  return (
    <Modal
      data-testid="ota-notification-modal"
      className="compliance-modal"
      title=""
      visible={visible}
      footer={null}
      closable
      width={750}
      centered
      onCancel={() => actions.hideModal()}
    >
      <div className="compliance-modal-body">
        <Space direction="vertical" size="small">
          <h1 className="title">Action Needed: New Software Available</h1>
          <div>
            There is a new software version available for your aircraft. It is important that you
            update your aircraft as soon as possible to ensure your system is up to date and
            delivering the best experience.
          </div>
          <div>
            {nonCompliantAccounts?.map(account => (
              <div className="account-bullet-wrapper" key={account.accountGuid}>
                {`- ${account.accountName}: ${account.nonCompliantLRUCount} aircraft to update. (`}
                <Link
                  className="compliance-link"
                  to={{ pathname: `/ota/overview/${account.accountGuid}`, hash: '' }}
                  onClick={() => actions.hideModal()}
                >
                  click here to update
                </Link>
                )
              </div>
            ))}
          </div>
          <div className="button-wrapper">
            <Button
              type="primary"
              className="compliance-button"
              onClick={() => actions.submitApproval(nonCompliantAccounts)}
            >
              Update Now
            </Button>
          </div>
        </Space>
      </div>
    </Modal>
  );
};

export default OtaNotificationModal;
